import {
	MapType,
	ModelTypes,
	ValueTypes,
	ZeusSelect,
} from '@goodlok/sdk/generated/content_role_admin'
import { ShiftsProfileFragment } from './ShiftsProfileFragment'

export function TimetableShiftFragment() {
	return ZeusSelect<ValueTypes['TimetableShift']>()({
		id: true,
		locked: true,
		shiftsProfile: [{}, ShiftsProfileFragment()],
		queueItem: [
			{},
			{
				id: true,
				unassignInfo: [
					{},
					{
						reason: [
							{},
							{
								id: true,
								name: true,
							},
						],
						hoursMissed: true,
					},
				],
				start: true,
				end: true,
			},
		],
		swapInfo: [
			{},
			{
				assigned: true,
				confirmed: true,
				requested: true,
				swappedShiftsProfile: [{}, ShiftsProfileFragment()],
			},
		],
		isOvertime: true,
	})
}

export type TimetableShiftResult = MapType<
	ModelTypes['TimetableShift'],
	ReturnType<typeof TimetableShiftFragment>
>
